/**
* @name APP Integration
* @autor VigneshKumar Somayaji
* @description
* # name controller --> executeDataController
*/

	export default class executeDataController {

		constructor($scope,$http,$resource,$timeout,ngNotify,UserInfoConstant,$state,$interval,$cookies,SERVICE_URL_CONSTANT,integrationServices) {


		      	var vm = this;
		      	$scope.userDetails='';
		      	$scope.id=0;
		      	$scope.setProcess=[];
		       
		        var sumInterval ={};


                 $scope.Ejacutar=function(title,fid){

                    var ejaculatorProcess=$scope.setProcess;

					$scope.pingMethod = function pingMethod() {
                    var cookiesProcess=$scope.setProcess;
                   
                            if(typeof cookiesProcess[0].fid!=='undefined'){
					                      for(var i in cookiesProcess){

					                      	

										                integrationServices.services.pingEtlExecutable({'id': cookiesProcess[i].processID}).
										                        $promise.then((response) => {
							                                    console.log('pingEtlExecutable',response);
							                                    var pingEtlExecutable=response.executablefeatures[i];
										                    	if(pingEtlExecutable.id_status!=1 && pingEtlExecutable.id_status!=2){
																		$('#execution_button_'+cookiesProcess[i].fid).addClass('bg-success');
																		$('#execution_button_'+cookiesProcess[i].fid).html(pingEtlExecutable.statues);
																		$('#execution_button_'+cookiesProcess[i].fid).removeClass('bg-warning');
																		delete cookiesProcess[i];
																		//$cookies.remove('setProcess');
																		$scope.setProcess=[];
																		$scope.setProcess.push(cookiesProcess)
																		// $cookies.putObject('setProcess',cookiesProcess);
										                    	}
												                    }, (err) => {
														      	ngNotify.set('No se ha podido conectar con el servicio','error');
															})

												
					                        }

		                        }else{
										$interval.cancel(sumInterval);
										$scope.setProcess=[]
									}
                          
					}

                 
                     var obj=[];
                      console.log('it manger',ejaculatorProcess);
                     if(ejaculatorProcess.length==0){

                            // if($scope.executiondata[0].execution_status)
                                var param={fid:fid,user_id:$scope.userDetails.id,jobname:$scope.executiondata[0].ds_job_name,
                                           execution_status:$scope.executiondata[0].execution_status}
								integrationServices.services.setExecutionDetails(param).$promise.then((dataReturn) => {

									    sumInterval = $interval($scope.pingMethod, 30000);
										$scope.id= dataReturn.data;
										$scope.setProcess.push({processID:dataReturn.data,
											       title:title,
											      fid:fid});
										// $cookies.putObject('setProcess',obj);
										$('#execution_button_'+fid).addClass('bg-warning');
										$('#execution_button_'+fid).html('En ejecucion');
										$('#execution_button_'+fid).removeClass('label-danger');
								}, (err) => {
								ngNotify.set('No se ha podido conectar con el servicio','error');
								})



                     }else{

                     	// console.log('yyyyyyy',ejaculatorProcess);
                     	// console.log('sumInterval',sumInterval);
                     	if (sumInterval !== null && ejaculatorProcess[0].fid == fid ) {
                     		 sumInterval = $interval($scope.pingMethod, 5000);
                     		 $('#execution_button_'+fid).addClass('bg-warning');
							 $('#execution_button_'+fid).html('En ejecucion');
							 $('#execution_button_'+fid).removeClass('label-danger');
							 $('#execution_button_'+fid).removeClass('bg-success');
                     	}else{
                     	     ngNotify.set('Espere a que se complete el proceso','error');
                     	}
                     
                     }
                 } ;   


               /// process not terminated


               			integrationServices.services.getExecutionDetails().$promise.then((dataReturn) => {
				            if(dataReturn.data.lenght == 0){

				            }else{

							 $timeout(function () {
							     $scope.userDetails=$scope.userDetails=UserInfoConstant[0].details[0].user;
								 $scope.executiondata=dataReturn.data;

								 for(var  i in dataReturn.data){
								 	// $scope.setProcess=	$scope.id= dataReturn.data;
									 	if(dataReturn.data[i].execution_status==1 || dataReturn.data[i].execution_status==2){
									 		$scope.setProcess.push({processID:dataReturn.data[i].exection_id,
												      title:dataReturn.data[i].feature_name,
												      fid:dataReturn.data[i].fid});	
									 	}

								 }

									try{
									var ejap=$scope.setProcess;

									if(typeof ejap !== 'undefined' || ejap[0]!=null ){
									$scope.Ejacutar(ejap[0].title,ejap[0].fid);
										$timeout(function () {
											console.log('vfvvvvvv',ejap);
											$('#execution_button_'+ejap[0].fid).addClass('bg-warning');
											$('#execution_button_'+ejap[0].fid).html('En ejecucion');
											$('#execution_button_'+ejap[0].fid).removeClass('bg-success');
											$('#execution_button_'+ejap[0].fid).removeClass('bg-danger');
										}, 3000);
									}        
									}catch(e){
									console.log('process  terminated',e);
									}



							 }, 1000);


				            }
				        }, (err) => {
				             ngNotify.set('No se ha podido conectar con el servicio','error');
				   });

				        

			}

  }

executeDataController.$inject=['$scope','$http','$resource','$timeout','ngNotify','UserInfoConstant','$state','$interval','$cookies','SERVICE_URL_CONSTANT','integrationServices']





// WEBPACK FOOTER //
// ./src/app/integration-front/integration_action/execute/executeDataController.js